import { InjectionToken } from '@angular/core';
import { AppEventsBase } from '@core/models/app-events.models';

export const APP_EVENTS: InjectionToken<AppEventsBase> = new InjectionToken('APP_EVENTS');
